import type { EmailAssistantRecipientRuleOption } from "./EmailAssistantQueryContextTypes";

export const parseDelimitedQueryValues = (value: string | null): string[] =>
  (value ?? "")
    .split(",")
    .map((item) => item.trim())
    .filter((item) => item.length > 0);

export const buildSelectedCountLabel = (
  ids: readonly string[],
  fallbackCount: string | null,
  singular: string,
  plural: string,
): string => {
  const parsedFallback = Number(fallbackCount ?? "");
  const count =
    ids.length || (Number.isFinite(parsedFallback) ? parsedFallback : 0);

  if (count <= 1) {
    return `1 selected ${singular}`;
  }

  return `${count} selected ${plural}`;
};

export const organisationRecipientRules: EmailAssistantRecipientRuleOption[] = [
  {
    id: "lead_user",
    label: "Primary user of the organisation",
    detail:
      "Email & Comms resolves the organisation lead user and checks preferences before a job can run.",
  },
  {
    id: "all_users",
    label: "Everyone with access",
    detail:
      "Email & Comms resolves active organisation users, removes duplicates, and applies preference and suppression checks.",
  },
];

export const partnerRecipientRules: EmailAssistantRecipientRuleOption[] = [
  {
    id: "lead_user",
    label: "Lead partner user only",
    detail:
      "Email & Comms resolves the lead partner user and applies permission, preference, and suppression checks before customer delivery.",
  },
  {
    id: "all_users",
    label: "All partner users",
    detail:
      "Email & Comms resolves partner users and applies permission, preference, and suppression checks before customer delivery.",
  },
];

export const selectedUsersRecipientRules: EmailAssistantRecipientRuleOption[] =
  [
    {
      id: "selected_users",
      label: "Selected users",
      detail:
        "Email & Comms resolves only the selected users, removes duplicates, and checks preferences before creating the manual job.",
    },
  ];

export const buildProfileRecipientRules = (
  baseRules: EmailAssistantRecipientRuleOption[],
  selectedUserIds: readonly string[],
): EmailAssistantRecipientRuleOption[] =>
  selectedUserIds.length > 0
    ? [...selectedUsersRecipientRules, ...baseRules]
    : baseRules;
